import { NAF_REV_2_SUBCLASSES, WZ_2025_SUBCLASSES } from '../data/industry-codes.js';
export const INDUSTRY_CODE_VISIBLE_LIMIT = 100;
/** Map national divisions to the ERP's broader reporting categories. */
function industryForCode(code) {
    const division = Number(code.slice(0, 2));
    if (division >= 1 && division <= 3)
        return 'AGRICULTURE';
    if (division >= 5 && division <= 39)
        return 'MANUFACTURING';
    if (division >= 41 && division <= 43)
        return 'CONSTRUCTION';
    if (code === '45.31Z')
        return 'WHOLESALE';
    if (code === '45.20A' || code === '45.20B')
        return 'SERVICES';
    if (division === 45 || division === 47)
        return 'RETAIL';
    if (division === 46)
        return 'WHOLESALE';
    if (division >= 49 && division <= 53)
        return 'LOGISTICS';
    if (division === 55 || division === 56)
        return 'GASTRONOMY';
    if (division === 84)
        return 'PUBLIC_SECTOR';
    if (division >= 86 && division <= 88)
        return 'HEALTHCARE';
    if (division >= 58 && division <= 96)
        return 'SERVICES';
    return 'OTHER';
}
function catalogue(rows) {
    return rows.map(([code, name]) => ({ code, name, industry: industryForCode(code) }));
}
const germanCodes = catalogue(WZ_2025_SUBCLASSES);
const frenchCodes = catalogue(NAF_REV_2_SUBCLASSES);
export function industryCodeOptions(countryCode) {
    return countryCode === 'FR' ? frenchCodes : germanCodes;
}
export function findIndustryCode(countryCode, code) {
    return industryCodeOptions(countryCode).find((entry) => entry.code === code);
}
//# sourceMappingURL=industry-codes.js.map